import { render, staticRenderFns } from "./SelectedFramework.vue?vue&type=template&id=f278ae5a&scoped=true&"
import script from "./SelectedFramework.vue?vue&type=script&lang=js&"
export * from "./SelectedFramework.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFramework.vue?vue&type=style&index=0&id=f278ae5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278ae5a",
  null
  
)

export default component.exports